<template>
    <div>
        <h1 :class="this.$vuetify.breakpoint.smAndDown ? 'text-h5 text-center' : 'secondary--text text-h2'">
            Tell us about your company
        </h1>
        <h3 class="secondary--text text-h5">
            Almost done! Just a few more details to set up your account.
        </h3>

        <p v-if="submitError" style="color: red" class="mt-4">{{ submitError }}</p>

        <v-form ref="form" v-model="valid" class="mt-4">
            <h4 class="text-overline section-title mb-2">Company Info</h4>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="Company Name" required v-model="form.companyName" :rules="requiredRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="Website" v-model="form.website"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-select
                        label="Time Zone" :items="timeZones" required v-model="form.timeZone" :rules="requiredRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="8">
                    <v-text-field
                        label="Address" required v-model="form.address" :rules="requiredRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field
                        label="Address 2" v-model="form.address2"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="City" required v-model="form.city" :rules="requiredRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                    <v-select
                        label="State" :items="states" required v-model="form.state" :rules="requiredRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-select>
                </v-col>
                <v-col cols="6" sm="3">
                    <v-text-field
                        label="Zip" required v-model="form.zip" :rules="requiredRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>

            <h4 class="text-overline section-title mb-2 mt-2">User Info</h4>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="First Name" required v-model="form.firstName" :rules="requiredRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="Last Name" required v-model="form.lastName" :rules="requiredRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field
                        label="Phone" required v-model="form.phone" v-mask="'(###) ###-####'" :rules="phoneRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="Password" type="password" required v-model="form.password" :rules="passwordRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="Confirm Password" type="password" required v-model="confirmPassword" :rules="confirmPasswordRule"
                        :color="!this.$vuetify.breakpoint.smAndDown ? 'iq_dark' : 'iq_light'"
                        :background-color="!this.$vuetify.breakpoint.smAndDown ? 'iq_light' : ''"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-form>

        <v-footer :app="this.$vuetify.breakpoint.smAndDown" padless class="px-0 bg-transparent">
            <v-container fluid class="pa-0">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card-actions class="d-flex justify-space-between px-0">
                            <v-btn x-large outlined color="primary" :loading="loading" :disabled="!valid" @click="submit">
                                Create Account
                            </v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-container>
        </v-footer>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "AccountDetails",
    data: () => ({
        valid: false,
        loading: false,
        submitError: "",
        confirmPassword: "",
        form: {
            companyName: "",
            website: "",
            timeZone: "",
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            firstName: "",
            lastName: "",
            phone: "",
            password: ""
        },
        states: [ 'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL',
            'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
            'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
            'VI', 'VA', 'WA', 'WV', 'WI', 'WY' ],
        timeZones: [
            'Pacific Time (US & Canada)',
            'Mountain Time (US & Canada)',
            'Central Time (US & Canada)',
            'Eastern Time (US & Canada)',
            'Alaska',
            'Hawaii'
        ],
        requiredRule: [v => !!v || "Required."]
    }),
    computed: {
        ...mapGetters('messageIqSignup', { billingInfo: 'getBillingInfo' }),
        phoneRule() {
            return [
                v => !!v || "Required.",
                v => this.validPhone(v) || "Please enter a valid phone number."
            ];
        },
        passwordRule() {
            return [
                v => !!v || "Required.",
                v => (v && v.length >= 8) || "Password must be at least 8 characters."
            ];
        },
        confirmPasswordRule() {
            return [
                v => !!v || "Required.",
                v => v === this.form.password || "Passwords do not match."
            ];
        }
    },
    created() {
        // Carry over what was already entered on the payment step so the lead
        // isn't asked to re-type their company name/address.
        if (this.billingInfo) {
            this.form.companyName = this.billingInfo.companyName || "";
            this.form.address = this.billingInfo.address || "";
            this.form.address2 = this.billingInfo.address2 || "";
            this.form.city = this.billingInfo.city || "";
            this.form.state = this.billingInfo.state || "";
            this.form.zip = this.billingInfo.zip || "";
            this.form.firstName = this.billingInfo.firstName || "";
            this.form.lastName = this.billingInfo.lastName || "";
        }
    },
    methods: {
        ...mapActions('messageIqSignup', ['completeSignup']),
        async submit() {
            this.submitError = "";

            if (!this.$refs.form.validate()) {
                return;
            }

            if (this.form.password !== this.confirmPassword) {
                this.submitError = "Passwords do not match.";
                return;
            }

            this.loading = true;

            try {
                await this.completeSignup({
                    companyName: this.form.companyName,
                    website: this.form.website,
                    timeZone: this.form.timeZone,
                    address: this.form.address,
                    address2: this.form.address2,
                    city: this.form.city,
                    state: this.form.state,
                    zip: this.form.zip,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    phone: this.form.phone,
                    password: this.form.password
                });

                // Password is sent to the backend above to create the Auth0 user and is
                // never needed again on the client - clear it immediately rather than
                // holding it in Vuex state.
                this.form.password = "";
                this.confirmPassword = "";

                this.$router.push('/signup/message-iq/confirmation');
            } catch (err) {
                this.submitError = (err.response && err.response.data && err.response.data.message)
                    || "We were unable to create your account. Please try again.";
                console.error(err);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.section-title {
    letter-spacing: 1.5px;
    color: #ed0c87;
    font-weight: 700;
}
</style>
